import Request from '@/plugins/request'

export function getOrderImports(params) {
  return Request.get('order-imports', { params })
}

export function createOrderImport() {
  return Request.get(`order-imports/create`)
}

export function storeOrderImport(data) {
  return Request.post('order-imports', data)
}

export function updateOrderImport(id, data) {
  return Request.put(`order-imports/${id}`, data)
}

export function editOrderImport(id) {
  return Request.get(`order-imports/${id}/edit`)
}

export function destroyOrderImport(id) {
  return Request.delete(`order-imports/${id}`)
}

// 订单导入信息
export function importOrder(data) {
  return Request.post(`order-imports/import`, data)
}

// 导入订单记录生成线下订单
export function importOrderOffline(data) {
  return Request.post(`order-imports/order-offline`, data)
}

// 销售单导出
export function exportOrder(params) {
  return Request.get('order-imports/export', { params })
}
